import { render, staticRenderFns } from "./TaxInfoModal.vue?vue&type=template&id=4e0009ec&scoped=true"
import script from "./TaxInfoModal.vue?vue&type=script&lang=js"
export * from "./TaxInfoModal.vue?vue&type=script&lang=js"
import style0 from "./TaxInfoModal.vue?vue&type=style&index=0&id=4e0009ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0009ec",
  null
  
)

export default component.exports